import React from "react";
import { SUIT_META, RANK_LABEL } from "./cardThemes";

// One playing card. Renders either a zombie-themed back or the rank/suit
// face. Supports drag (pointer-based) and click selection via props.
function CardBase({
  card,
  selected = false,
  hinted = false,
  onPointerDown,
  onClick,
  draggable = true,
  style,
  ariaLabel,
}) {
  if (!card) return null;
  const meta = SUIT_META[card.suit];
  const rank = RANK_LABEL[card.rank];

  if (!card.faceUp) {
    return (
      <div
        className={`zs-card zs-card-back ${selected ? "selected" : ""} ${hinted ? "hinted" : ""}`}
        style={style}
        onPointerDown={draggable ? onPointerDown : undefined}
        onClick={onClick}
        aria-label={ariaLabel || "Face-down card"}
        data-testid={`card-back-${card.id}`}
      >
        <div className="zs-card-back-pattern" aria-hidden="true">
          <div className="zs-card-back-zombie" />
        </div>
      </div>
    );
  }

  return (
    <div
      className={`zs-card zs-card-face ${selected ? "selected" : ""} ${hinted ? "hinted" : ""}`}
      style={{ ...style, "--suit-color": meta.color }}
      onPointerDown={draggable ? onPointerDown : undefined}
      onClick={onClick}
      aria-label={ariaLabel || `${rank} of ${meta.name}`}
      data-testid={`card-${card.id}`}
    >
      <div className="zs-card-corner top-left">
        <span className="zs-card-rank">{rank}</span>
        <span className="zs-card-suit">{meta.symbol}</span>
      </div>
      <div className="zs-card-center" aria-hidden="true">{meta.symbol}</div>
      <div className="zs-card-corner bottom-right">
        <span className="zs-card-rank">{rank}</span>
        <span className="zs-card-suit">{meta.symbol}</span>
      </div>
    </div>
  );
}

export default React.memo(CardBase);
